<template>
  <div>
    <script
      src="https://accounts.google.com/gsi/client"
      type="application/javascript"
      @load="initSignIn"
      async
      defer
    ></script>

    <h4 class="mb-4">{{ $t('login') }}</h4>
    <div class="form-group">
      <div id="gSignInButton" />
    </div>
    <div class="text-danger">{{ error }}</div>
  </div>
</template>

<script>
import _ from 'lodash';
import config from '@/config';
import store from '@/store';
import { mapState } from 'vuex';
import Api from '@/store/jsonapi';
import axios from 'axios';
import $ from 'jquery';

export default {
  data: function () {
    return {
      email: '',
      password: '',
      error: '',
      google_user: null,
      id_token: ''
    };
  },
  props: ['view'],
  computed: mapState(['token', 'staff', 'refresh_token']),
  async mounted() {
    // Keeps session alive with refresh token
    setInterval(() => {
      this.refreshToken();
    }, 5 * 60 * 1000); // 5 minutes
  },
  methods: {
    initSignIn() {
      google.accounts.id.initialize({
        client_id: process.env.GOOGLE_CLIENT_ID,
        callback: this.onSigning
      });

      google.accounts.id.renderButton(document.getElementById('gSignInButton'), {
        type: 'standard',
        text: 'sign_in_with',
        theme: 'outline',
        size: 'large',
        width: '400'
      });
      google.accounts.id.prompt();
    },
    async onSigning(googleUser) {
      this.id_token = googleUser.credential;

      try {
        let { data } = await axios.post(
          config.api_endpoint + '/oauth/token',
          {
            grant_type: 'assertion',
            provider: 'google',
            assertion: this.id_token
          },
          {
            headers: {
              'X-TenantName': 'backend'
            }
          }
        );

        this.$store.commit('setToken', 'Bearer ' + data.access_token);
        this.$store.commit('setRefreshToken', data.refresh_token);

        let { data: staff } = await Api.find('staffs', 'current', {
          include: 'user_group'
        });
        this.$store.commit('setStaff', staff);
      } catch ({ response }) {
        this.error = response.data.error_description;
      }
    },
    sign_out: function () {
      this.$store.commit('setToken', null);
    },
    refreshToken() {
      $.post({
        url: config.api_endpoint + '/oauth/token',
        data: {
          grant_type: 'refresh_token',
          refresh_token: this.refresh_token
        },
        dataType: 'json',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        headers: {
          'X-TenantName': 'backend',
          Authorization: this.token
        }
      })
        .done((res, statusText, jqXHR) => {
          this.$store.commit('setToken', 'Bearer ' + res.access_token);
          this.$store.commit('setRefreshToken', res.refresh_token);
        })
        .fail((res) => {
          this.error = res.responseJSON;
        });
    }
  },
  store
};
</script>
